export default [
  // Standard textfield display options will be inherited from base form
  // Add any custom display options here if needed
];
